import { PageShell } from '@components/layout/PageShell.js'
import { ModePageHeader } from '@components/layout/ModePageHeader.js'
import { CardListSkeleton, PageHeaderSkeleton } from '@components/primitives/Skeleton.js'
import { ChecklistPendentesView } from '@components/guia/ChecklistPendentesView.js'
import { useChecklistPendentes } from '@hooks/useChecklistPendentes.js'

export function ChecklistPendentesPage() {
  const { modulos, totalItens, totalPassos, isLoading, toggleItem } = useChecklistPendentes()

  if (isLoading) {
    return (
      <PageShell>
        <PageHeaderSkeleton label='Carregando checklists…' />
        <section className='cf3-block'>
          <CardListSkeleton count={3} label='Carregando checklists…' />
        </section>
      </PageShell>
    )
  }

  return (
    <PageShell>
      <ModePageHeader
        title='Checklists do guia'
        subtitle={
          totalItens > 0
            ? `${totalItens} ${totalItens === 1 ? 'item' : 'itens'} em ${totalPassos} ${totalPassos === 1 ? 'etapa' : 'etapas'} anteriores à sua etapa atual.`
            : 'Itens do guia em etapas que você já passou. Não é a lista de tarefas do canteiro.'
        }
      />

      <section className='cf3-block'>
        <ChecklistPendentesView
          modulos={modulos}
          totalItens={totalItens}
          onToggleItem={toggleItem}
        />
      </section>

      {totalItens > 0 && (
        <div className='cf3-block__card cf3-insight'>
          <p className='cf3-insight__text'>
            Marque os itens aqui ou abra a etapa para ver o contexto completo. Etapas futuras não
            aparecem nesta lista. Apenas etapas que você já deixou para trás.
          </p>
        </div>
      )}
    </PageShell>
  )
}
